import type { PublicBonuses, PublicLevel } from '@/types';
import { usePublicEngagementsStore } from '@/stores';
import { useToast } from 'primevue/usetoast';
import { computed, ref } from 'vue';

export function usePublicEngagements() {
    const publicEngagementsStore = usePublicEngagementsStore();
    const toast = useToast();
    const bonusesGetText = 'get_bonuses';
    const levelsGetText = 'get_levels';
    const loadingFlag = ref(false);
    const publicBonuses = computed<PublicBonuses>(() => publicEngagementsStore.publicBonuses);
    const publicLevels = computed<PublicLevel[]>(() => publicEngagementsStore.publicLevels);
    async function toGetPublicBonuses() {
        loadingFlag.value = true;
        try {
            await publicEngagementsStore.awaitGetPublicBonuses();
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: bonusesGetText, detail: error, life: 4000 });
            throw error;
        } finally {
            loadingFlag.value = false;
        }
    }
    async function toGetPublicLevels() {
        loadingFlag.value = true;
        try {
            await publicEngagementsStore.awaitGetPublicLevels();
        } catch (error) {
            toast.add({ severity: 'error', group: 'global', summary: levelsGetText, detail: error, life: 4000 });
            throw error;
        } finally {
            loadingFlag.value = false;
        }
    }
    return {
        publicBonuses,
        publicLevels,
        toGetPublicBonuses,
        toGetPublicLevels,
        loadingFlag
    };
}
